<template>

  <div>

    <!-- stepper -->
    <v-stepper v-if="bookingContext" v-model="step" class="d-flex flex-column" style="height: 100vh;">

      <v-stepper-header>
        <!-- Options -->
        <v-stepper-step :complete="step > BookingSteps.OPTIONS" :step="BookingSteps.OPTIONS">
          {{$t('booking.options.title')}}
        </v-stepper-step>

        <v-divider></v-divider>

        <!-- UserInfo -->
        <v-stepper-step :complete="step > BookingSteps.USER_INFO" :step="BookingSteps.USER_INFO">
              <span>
                <v-icon>mdi-account-circle-outline</v-icon> {{$t('booking.user_info.title')}}
              </span>
        </v-stepper-step>

        <v-divider></v-divider>

        <!-- Payment -->
        <v-stepper-step :complete="step > BookingSteps.PAYMENT" :step="BookingSteps.PAYMENT">
              <span>
                <v-icon>mdi-credit-card-outline</v-icon> {{$t('booking.payment.title')}}
              </span>
        </v-stepper-step>

        <v-divider></v-divider>

        <!-- Confirmation -->
        <v-stepper-step :step="BookingSteps.CONFIRMATION">
          {{$t('booking.confirmation.title')}}
        </v-stepper-step>

      </v-stepper-header>

      <v-stepper-items id="stepper-content" class="flex-grow-1" style="overflow-y: auto;">

        <!-- Options -->
        <v-stepper-content :step="BookingSteps.OPTIONS">
          <div class="p-4">
            <BookingOptionsStep v-if="step === BookingSteps.OPTIONS" :bookingContext="bookingContext"
                                @nextStep="goToStep(BookingSteps.USER_INFO, $event)"/>
          </div>
        </v-stepper-content>

        <!-- UserInfo -->
        <v-stepper-content :step="BookingSteps.USER_INFO">
          <div class="p-4">
            <BookingUserInfoStep v-if="step === BookingSteps.USER_INFO" :bookingContext="bookingContext"
                                 @nextStep="goToStep(BookingSteps.PAYMENT, $event)"/>
          </div>
        </v-stepper-content>

        <!-- Payment -->
        <v-stepper-content :step="BookingSteps.PAYMENT">
          <div class="p-4">
            <BookingPaymentStep v-if="bookingContext.paymentType === 'dz'" :bookingContext="bookingContext"
                                @nextStep="goToStep(BookingSteps.CONFIRMATION, $event)"/>
            <BookingPaymentStripeStep v-if="bookingContext.paymentType === 'stripe' && BookingSteps.PAYMENT" :bookingContext="bookingContext"
                                      @nextStep="goToStep(BookingSteps.CONFIRMATION, $event)"/>
          </div>
        </v-stepper-content>


        <!-- Confirmation -->
        <v-stepper-content :step="BookingSteps.CONFIRMATION">
          <div class="p-4">
            <BookingConfirmationStep v-if="step === BookingSteps.CONFIRMATION" :bookingContext="bookingContext"
                                     @nextStep="closeProcess()"/>
          </div>
        </v-stepper-content>

      </v-stepper-items>

    </v-stepper>

    <div v-if="error" class="ma-16">

      <v-alert type="error" color="red">
        {{$t('shared.unkown_error')}} : {{error.message}}
      </v-alert>

    </div>

  </div>
</template>

<script>
  import { BookingOptionsStep, BookingUserInfoStep, BookingPaymentStep, BookingConfirmationStep } from '../components';
  import { BookingSteps } from '../models';
  import { BookingService } from "../services";
  import BookingPaymentStripeStep from '../components/BookingPaymentStripeStep'

  export default {
    data () {
      return {
        fab: false,
        step: BookingSteps.OPTIONS,
        BookingSteps,
        bookingContext: null,
        error: null
      }
    },
    methods: {
      goToStep (step, bc) {
        console.log("Go to next;", step, bc)
        switch (step) {
          case BookingSteps.OPTIONS:
            break;
          case BookingSteps.USER_INFO:
            this.bookingContext = bc;
            break;
          case BookingSteps.PAYMENT:
            this.bookingContext = bc;
            break;
          case BookingSteps.CONFIRMATION:
            this.bookingContext = bc;
            // save the updated context in store
            this.$store.commit('booking/setContext', this.bookingContext);
            break;
        }
        this.step = step;
        document.getElementById('stepper-content').scrollTo(0, 0);
      },
      closeProcess () {
        console.log("closeProcess",this.$router);
        this.$store.commit('booking/setContext', null);
        this.$router.push( 'locations');
      }
    },
    mounted () {
      // get the bookingContext from store
      const bookingContext = this.$store.getters['booking/context'];
      // check errors in the bookingContext
      try {
        BookingService.checkBookingError(bookingContext, this.step);
        // no error found
        this.bookingContext = bookingContext;
      } catch (error) {
        // show error
        this.error = error;
      }
    },
    components: {
      BookingPaymentStripeStep,
      BookingPaymentStep,
      BookingOptionsStep,
      BookingUserInfoStep,
      BookingConfirmationStep
    }
  }
</script>
